export class FormOutputModel {
  isValid: boolean;
  value: string;
}
